<mat-spinner *ngIf="!loaded()" diameter="50"></mat-spinner>

<div
  class="identity-container"
  *ngIf="loaded()"
>
  <div class="save-header">
    <h2 data-test="title-identity">Your personal identity</h2>
  
    <div>
      <iris-button
        (click)="onCancelAll()"
        [disabled]="saving || (ethnicityForm?.pristine && genderForm?.pristine && lgbtIdentifiedFormControl?.pristine)"
        [buttonType]="irisButtonTypes.SECONDARY"
        aria-label="Cancel"
        data-test="cancel-identity-changes"
      >
        Cancel
      </iris-button>
      <iris-button
        (click)="onSaveAll()"
        [disabled]="saving || (ethnicityForm?.pristine && genderForm?.pristine && lgbtIdentifiedFormControl?.pristine)"
        aria-label="Save"
        data-test="save-identity-changes"
      >
        Save
      </iris-button>
    </div>
  </div>

  <p class="iris-body-responsive">Many clients are looking for someone who shares aspects of their identity–this information may show up for potential clients who request a provider with a specific identity.</p>

  <iris-card class="card">

    <form [formGroup]="ethnicityForm" class="ethnicity-section">
      <iris-form-field
        label="Race/Ethnicity"
        data-test="subtitle-identify-as"
        [customErrorMessages]="{
          'needsOne': 'This field is required.'
        }"
      >
        <sondermind-grid-layout
          formGroupName="ethnicities"
          data-test="identitities-checkbox"
          [refDatumItems]="filteredEthnicites"
        >
          <iris-checkbox
            *ngFor="let ethnicity of filteredEthnicites"
            [formControlName]="ethnicity.id.toString()"
            [attr.data-test]="'list-checkbox-' + ethnicity.title"
          >
            {{ ethnicity.title }}
          </iris-checkbox>
        </sondermind-grid-layout>
      </iris-form-field>
    </form>

    <form [formGroup]="genderForm" class="gender-section">
      <iris-form-field
        label="Gender"
      >
        <iris-dropdown
          formControlName="genderId"
          [options]="genderOptions"
          data-test="gender"
        >
        </iris-dropdown>
      </iris-form-field>
    </form>

    <section class="lgbtqia-section">
      <iris-form-field
        label="Do you identify as LGBTQIA+?"
        data-test="lgbt-question"
      >
        <iris-radio-group
          [canBeNull]="true"
          [formControl]="lgbtIdentifiedFormControl"
          [options]="lgbtIdentifiedOptions">
        </iris-radio-group>
      </iris-form-field>
    </section>
  </iris-card>
</div>
